<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-5 mx-auto pt-3">
        <h1 class="text-center pb-3">{{$t("loginPageTitle")}}</h1>
        <login-form @loginSuccess="onLoginSuccess"></login-form>
      </div>
    </div>
  </div>
</template>


<script>
import LoginForm from '../../components/forms/LoginForm'

export default {
  components: {
    loginForm: LoginForm,
  },
  methods: {
    onLoginSuccess() {
      this.$router.push('/')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/pages/auth/LoginPage.vue